import React, { Component, Fragment } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, exibeMensagemAviso, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import {formataData, formataDataMesAno} from '../../utils/formatadorData';
import { Pagination } from "../Pagination/Pagination";
import {getMessagemErro} from "../../utils/erro";

import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";
import './Billing.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, exibeMensagemAviso, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const BillingList =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				tiposContrato: [],
				tipoContrato: 'A',
				situacoes: [],
				situacao: 'P',
				contratos: [],
				contrato: '',
				referencias: [],
				referencia: '',
				orgaos: [],
				orgao: '',
				fornecedoras: [],
				fornecedora: '',
				resultadoPesquisa: {},
				pesquisaExecutada : false,
				carregandoTiposContrato: false,
				carregandoSituacoes: false,
				carregandoContratos: false,
				carregandoReferencias: false,
				carregandoOrgaos: false,
				botoesHabilitados : true,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.handleTipoContratoChange = this.handleTipoContratoChange.bind(this);
			this.handleContratoChange = this.handleContratoChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.carregarTiposContratos = this.carregarTiposContratos.bind(this);
			this.carregarSituacoes = this.carregarSituacoes.bind(this);
			this.carregarContratos = this.carregarContratos.bind(this);
			this.carregarReferencias = this.carregarReferencias.bind(this);
			this.carregarFornecedoras = this.carregarFornecedoras.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.mostraRelatorioPrestacaoContasPDF = this.mostraRelatorioPrestacaoContasPDF.bind(this);
			this.mostraListaPrestacaoContasPDF = this.mostraListaPrestacaoContasPDF.bind(this);
			this.solicitacaoAssinaturaPrestacaoContasPendente = this.solicitacaoAssinaturaPrestacaoContasPendente.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Listar Declarações de Consumo</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			this.carregarSituacoes();
			this.carregarTiposContratos();
			this.carregarContratos(this.state.tipoContrato);
			this.carregarOrgaos();
			this.carregarFornecedoras();
		}

		renderForm() {
			const { tipoContrato, contrato, referencia, fornecedora, orgao, situacao, resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const { user } = this.props;
			const numberFormater = new Intl.NumberFormat('pt-BR', {useGrouping: true });

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label htmlFor="situacao">Situação do Ateste:</label>
										<select name="situacao" id="situacao" onChange={this.handleInputChange} value={situacao}>
											<option value="">Todas</option>
											{
												this.state.situacoes?.map(situacao =>
													<option 
														key={situacao.codigo} 
														value={situacao.codigo}>
														{situacao.nome}
													</option>
											)}
										</select>
										{this.state.carregandoSituacoes === true && 
										<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
							{ user.isAdministrador === true &&
								<div className="col-sd">
									<div className="field">
										<div className="input">
											<label htmlFor="tipoContrato">Tipo de Contrato:</label>
											<select name="tipoContrato" id="tipoContrato" onChange={this.handleTipoContratoChange} value={tipoContrato}>
												{
													this.state.tiposContrato?.map(tipoContrato =>
														<option 
															key={tipoContrato.codigo} 
															value={tipoContrato.codigo}>
															{tipoContrato.nome}
														</option>
												)}
											</select>
											{this.state.carregandoTiposContrato === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							}

							{user.isAdministrador === true && tipoContrato &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="contrato">Contrato:</label>
											<select name="contrato" id="contrato" onChange={this.handleContratoChange} value={contrato}>
												<option value="">{this.state.contratos?.length > 0 ? 'Todos' : 'Não há contratos cadastrados para o tipo selecionado'}</option>
												{
													this.state.contratos?.map(contrato =>
														<option 
															key={contrato.id} 
															value={contrato.id}>
															{contrato.nomeContrato} {'=>'} {formataData(contrato.inicioVigencia)} a {formataData(contrato.fimVigencia)}
														</option>
												)}
											</select>
											{this.state.carregandoContratos === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							}

							{user.isAdministrador === true && contrato &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="contrato">Referência:</label>
											<select name="referencia" id="referencia" onChange={this.handleInputChange} value={referencia}>
												<option value="">{this.state.referencias?.length > 0 ? 'Todas' : 'Não há referências cadastradas para o contrato selecionado'}</option>
												{
													this.state.referencias?.map(referencia =>
														<option 
															key={referencia.id} 
															value={referencia.id}>
															({formataDataMesAno(referencia.referencia)}) {'=>'} {formataData(referencia.periodoInicial)} a {formataData(referencia.periodoFinal)}
														</option>
												)}
											</select>
											{this.state.carregandoReferencias === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							}

						</div>

						{tipoContrato === 'A'&&
							<div className="row">
								{user.isAdministrador === true &&
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="consumidora">Órgao Consumidor:</label>
												{this.state.orgaos.length > 0 && 
													<select name="orgao" onChange={this.handleOrgaoChange} value={orgao}>
														<option value="">{this.state.orgaos?.length > 0 ? 'Todos' : 'Não há órgãos cadastrados'}</option>
														{
															this.state.orgaos.map(orgao =>
																<option 
																	key={orgao.id} 
																	value={orgao.id}>
																	{orgao.nome}
																</option>
														)}
													</select>
												}
												{this.state.carregandoOrgaos === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}

											</div>
										</div>
									</div>
								}
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>API:</label>
												<select name="fornecedora" onChange={this.handleInputChange} value={fornecedora}>
													<option value="">{this.state.fornecedoras?.length > 0 ? 'Todas' : "Não há API's cadastradas para o contrato/órgão selecionados"}</option>
														{
															this.state.fornecedoras?.map(fornecedora =>
																<option 
																	key={fornecedora.id} 
																	value={fornecedora.id}>
																	{fornecedora.nome}
																</option>
														)}
												</select>

											{this.state.carregandoFornecedoras === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							</div>
						}

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={this.mostraListaPrestacaoContasPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/"> 
									<div className="back-button">
										<button type="button" className="button is-secondary" disabled={!this.state.botoesHabilitados}>Voltar</button>
									</div>
								</Link>
							</div>
						</div>

						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Órgão</th>
												{tipoContrato === 'A' &&
													<th scope="col">API</th>
												}
												<th scope="col">Contrato</th>
												<th scope="col">Referência</th>
												{tipoContrato === 'A' &&
													<th scope="col" className="text-right">Consumo</th>
												}
												<th scope="col">Situação</th>
												<th scope="col">Envio Declaração Consumo</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((faturamentoOrgao, index) =>
													<tr key={index} >
														<td>{faturamentoOrgao.nomeOrgao}</td>
														{tipoContrato === 'A' &&
															<td>{faturamentoOrgao.nomeFornecedora}</td>
														}
														<td>{faturamentoOrgao.nomeContrato}</td>
														<td>{faturamentoOrgao.referencia}</td>
														{tipoContrato === 'A' &&
															<td className="text-right">{numberFormater.format(faturamentoOrgao.consumo)}</td>
														}

														<td>
															{faturamentoOrgao.nomeSituacao}
															{faturamentoOrgao.situacao === 'A' &&
																<Fragment>
																	<br/>
																	{faturamentoOrgao.assinante}
																	<br/>
																	{faturamentoOrgao.dataAssinatura}
																</Fragment>
															}
														</td>
														<td>
															{faturamentoOrgao.dataGeracaoFaturamento}
														</td>

														<td className="text-center">
															<div className="actions">
																{user.isAdministrador === true && faturamentoOrgao.situacao === 'P' && faturamentoOrgao.tipoContrato === 'A' &&
																	<button type="button" title="Enviar email ao gestor do órgão solicitando o ateste da declaração de consumo." onClick={() => this.solicitacaoAssinaturaPrestacaoContasPendente(faturamentoOrgao)}>
																		<span className="sr-only">Enviar email ao gestor do órgão</span>
																		<i className="fas fa-at"></i>
																	</button>
																}

																{Number(user.idOrgao) === faturamentoOrgao.orgao && faturamentoOrgao.situacao === 'P' &&
																	<Link to={`/billing/agreement/${faturamentoOrgao.id}`}>
																		<button type="button" title="Atestar a declaração de consumo.">
																			<span className="sr-only">Atestar a declaração de consumo</span>
																			<i className="fas fa-file-signature"></i>
																		</button>
																	</Link>
																}

																{Number(user.idOrgao) === faturamentoOrgao.orgao &&
																	<button type="button" title="Visualizar o relatório de declaração de consumo." onClick={() => this.mostraRelatorioPrestacaoContasPDF(faturamentoOrgao)}>
																		<span className="sr-only">Visualizar o relatório de declaração de consumo.</span>
																		<i className="fas fa-file-contract"></i>
																	</button>
																}
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma declaração de consumo encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		validaFormulario() {

			let mensagens = [];
			const {tipoContrato, contrato, fornecedora, referencia} = this.state;

			if(!tipoContrato || tipoContrato.trim().length === 0 ){
				mensagens.push({mensagem: "Tipo de Contrato é obrigatório."})
			} else {
				if(!contrato || contrato.trim().length === 0 ){
					mensagens.push({mensagem: "Contrato é obrigatório."})
				} else {
					if(!referencia || referencia.trim().length === 0 ){
						mensagens.push({mensagem: "Referência é obrigatório."})
					}
					if(tipoContrato === 'A' && !fornecedora){
						mensagens.push({mensagem: "API é obrigatório."})
					}
				}
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		handleTipoContratoChange(evento){
			const tipoContrato =  evento.target.value;

			this.setState({
				tipoContrato,
				contrato: '',
				contratos: [],
				referencia: '',
				referencias: [],
				fornecedora: '',
				fornecedoras: [],
				orgao: '',

			});

			this.carregarContratos(tipoContrato);
			if(tipoContrato === 'A'){
				this.carregarFornecedoras();
			}
		}

		handleContratoChange(evento){
			const contrato = evento.target.value;

			this.setState({
				contrato,
				referencia: "",
				referencias: [],
				fornecedora: '',
				fornecedoras:[],
			})

			this.carregarReferencias(contrato);
			if(this.state.tipoContrato === 'A') {
				this.carregarFornecedoras(contrato, this.state.orgao);
			}
		}

		handleOrgaoChange(evento){
			const orgao = evento.target.value;

			this.setState({
				orgao,
				fornecedora: '',
				fornecedoras: [],
			})

			this.carregarFornecedoras(this.state.contrato, orgao);
		}

		carregarTiposContratos() {
			if(this.props.user.isAdministrador === false) {
				return;
			}

			this.setState({carregandoTiposContrato: true})

			api.get('/api/contrato/tipos')
			.then(response => { this.setState({tiposContrato: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar os tipos de contrato", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			})
			.finally(() => this.setState({carregandoTiposContrato: false}));
		}

		carregarSituacoes() {
			this.setState({carregandoSituacoes: true})
		
			api.get('/api/prestacao-contas/situacoes')
			.then(response => { this.setState({situacoes: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar as situações de declaração de consumo", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			})
			.finally(() => this.setState({carregandoSituacoes: false}));
		}

		carregarContratos(tipoContrato) {
			if(this.props.user.isAdministrador === false || !tipoContrato) {
				return;
			}

			this.setState({carregandoContratos : true });
			api.get(`/api/contrato/tipo/${tipoContrato}`)
				.then(response => { 
					const contratos = response.data;
					this.setState({	contratos	})
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os contratos", erro)
					this.props.exibeMensagemErro("Erro durante o carregamento dos contratos")
				})
				.finally(() => {
					this.setState({carregandoContratos : false});
				});
		}

		carregarReferencias(contrato) {
			if(this.props.user.isAdministrador === false || !contrato) {
				return;
			}

			this.setState({carregandoReferencias : true });
			api.get(`/api/referencia-faturamento/contrato/${contrato}`)
			.then(response => { 
				const referencias = response.data;
				this.setState({	referencias	})
			 })
			.catch(erro => {
				console.log("Não foi possível recuperar as referências de faturamento do contrato", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento das referências de faturamento do contrato")
			})
			.finally(() => {
				this.setState({carregandoReferencias : false});
			});
		}

		carregarFornecedoras(contrato, orgao) {
			this.setState({carregandoFornecedoras : true});
			const idContrato = contrato ? contrato : '';
			const idOrgao = orgao ? orgao : '';

			api.get(`/api/aplicacao-fornecedora/faturavel/por-perfil-contrato-orgao?idContrato=${idContrato}&idOrgao=${idOrgao}`)
			.then(response => { this.setState(
				{
					fornecedoras: response.data,
				}
				) 
			})
			.catch(erro => {
				console.log("Não foi possível recuperar as aplicações fornecedoras ", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento das APIs")
			})
			.finally(() => this.setState({carregandoFornecedoras: false}));
		}

		carregarOrgaos() {
			if(this.props.user.isAdministrador === false){
				return;
			}

			this.setState({carregandoOrgaos : true });
			
			api.get('/api/orgao/consumidores/perfil-usuario')
			.then(response => { this.setState(
				{
					orgaos: response.data
				}
				) 
			})
			.catch(erro => {
				console.log("Não foi possível recuperar órgãos consumidores " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			}).finally(() => {
				this.setState({carregandoOrgaos : false});
			});

		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
		}

		executaPesquisaPaginada(pagina){

			const {situacao, tipoContrato, contrato, referencia, orgao, fornecedora} = this.state;
			const criterioPesquisa = {situacao, tipoContrato, contrato, referencia, orgao, fornecedora};
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/prestacao-contas/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando()
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as prestações de conta. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then( () => {
					this.props.escondeAguardando();
				});
		}

		mostraRelatorioPrestacaoContasPDF(faturamentoOrgao){

			const options = {
				method: 'post',
				url: `/api/prestacao-contas/relatorio/pdf/${faturamentoOrgao.id}`,
				responseType: 'arraybuffer'
			}

			this.props.limpaMensagem();
			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					let nomeRelatorio = 'RelatorioPrestacaoContas.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeRelatorio = contentDisposition.split("filename=")[1];
					}

					baixarArquivo(new Blob([response.data]), nomeRelatorio);

					const mensagem = response['headers']['mensagem'];
					if(mensagem) {
						this.props.exibeMensagemAviso(mensagem);
					}
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de declaração de consumo.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		mostraListaPrestacaoContasPDF(){
			const { tipoContrato, situacao, contrato, referencia, orgao, fornecedora } = this.state;
			const criterioPesquisa = { tipoContrato, situacao, contrato, referencia, orgao, fornecedora };

			const options = {
				method: 'post',
				url: '/api/prestacao-contas/lista/pdf',
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.limpaMensagem();
			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					let nomeRelatorio = 'DeclaracaoConsumo.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeRelatorio = contentDisposition.split("filename=")[1];
					}
					baixarArquivo(new Blob([response.data]), nomeRelatorio);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de declaração de consumo';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		solicitacaoAssinaturaPrestacaoContasPendente(faturamentoOrgao){

			const options = {
				method: 'post',
				url: `/api/prestacao-contas/solicitacao/assinatura/pendente/${faturamentoOrgao.id}`,
			}

			this.props.limpaMensagem();
			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
			.then(response => {
				this.props.exibeMensagemSucesso('Solicitação de assinatura da declaração de consumo enviada com sucesso!');
			})
			.catch(erro => {
				const mensagemInicial = 'Não foi possível enviar email solicitando a assinatura da declaração de consumo.';
				const msg = getMessagemErro(mensagemInicial, erro);
				console.log(JSON.stringify(msg));
				this.props.exibeMensagemErro(msg.mensagem, msg.erros);
			})
			.then (() =>{
				this.props.escondeAguardando();
				this.setState({botoesHabilitados:true});
			});
		}

		limparPesquisa(){
			this.props.limpaMensagem();

			this.setState({
				tipoContrato: 'A',
				orgao: '',
				fornecedora: '',
				fornecedoras: [],
				contrato: '',
				contratos: [],
				referencia: '',
				referencias: [],
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			});

			this.carregarContratos(this.state.tipoContrato);
			this.carregarFornecedoras();
		}
	}

) // redux
); // router